import ExperienceCardSkeleton from './ExperienceCardSkeleton';

export default ExperienceCardSkeleton;
